import EmailAlertsForm from './EmailAlertsForm';

export default EmailAlertsForm;
